import ToggleSwitch from "./toggle-switch"

export default ToggleSwitch
